import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { firebaseApp } from "../firebase";
import { useAuth } from "../contexts/AuthContext.jsx";

const ResumeGuard = ({ children }) => {
  const { user } = useAuth();
  const db = getFirestore(firebaseApp);
  const [loading, setLoading] = useState(true);
  const [hasResume, setHasResume] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      if (!user?.id) {
        setHasResume(false);
        setLoading(false);
        return;
      }
      try {
        const profSnap = await getDoc(doc(db, "userProfiles", user.id));
        const uploaded = profSnap.exists() ? !!profSnap.data()?.resumeUploaded : false;
        if (!cancelled) {
          setHasResume(uploaded);
          setLoading(false);
        }
      } catch {
        if (!cancelled) {
          setHasResume(false);
          setLoading(false);
        }
      }
    };
    check();
    return () => { cancelled = true; };
  }, [db, user?.id]);

  if (loading) {
    return (
      <div className="min-h-[300px] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-red-700 mx-auto"></div>
          <p className="mt-3 text-gray-600">Checking resume status...</p>
        </div>
      </div>
    );
  }

  if (!hasResume) {
    return <Navigate to="/job-seeker/resume-upload" replace />;
  }

  return <>{children}</>;
};

export default ResumeGuard;
